require('./multiMap.js');



//////////////////
// WEBPACK FOOTER
// ../~/angular-ui-bootstrap/src/multiMap/index.js
// module id = 380
// module chunks = 0